// extracted by mini-css-extract-plugin
export default {"container":"Subtitle_container__vUxTA","heading":"Subtitle_heading__QEi+b"};